import { Component, Input, EventEmitter, Output, OnInit } from "@angular/core";

import * as SurveyCreator from "survey-creator";

import "survey-creator/survey-creator.css";

SurveyCreator.StylesManager.applyTheme("modern");

@Component({
    moduleId: module.id,
    selector: 'survey-creator',
    templateUrl: 'survey-creator.component.html'
})

export class SurveyCreatorComponent implements OnInit {
  @Input()
  result: any;
  JSON: any = {};
  @Input() survey: any = {};

  creator;
  ngOnInit() {
    let creatorOptions = {};
    this.creator = new SurveyCreator.SurveyCreator("creatorElement", creatorOptions);
    this.creator.JSON = this.survey?.questions || {};
    this.creator.showToolbox = "right";
    this.creator.showPropertyGrid = "right";
    this.creator.rightContainerActiveItem("toolbox"); 
  }

  ngOnChanges() {
    if (this.creator) {
      this.creator.JSON = this.survey?.questions || {};
    }
  }

  getSurveyJson() {
    return this.creator.getSurveyJSON();
  }
}
